export const SimulationStatusTypes = {
  NEW: 'New',
  DONE: 'Done',
  FAILED: 'Failed',
  SKIPPED: 'Skipped',
  RUNNING: 'Running',
};

export const ApiInvocationStatus = {
  NOT_INVOKED: 'NOT_INVOKED',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',

   isComplete(status) {
    return status === this.SUCCEEDED || status === this.FAILED;
   }
};

export const URLs = {
  PROD: 'tools.profit-intelligence.selling-partners',
  PROD_: 'phoenix.profit-intelligence.selling-partners',
  ALPHA: 'tools-alpha.profit-intelligence.selling-partners',
  LOCAL: 'localhost'
};

export const LoggerEndpoints = {
  ALPHA: 'https://inv7v44pw2.execute-api.us-west-2.amazonaws.com/prod/v1/log',
  PROD: 'https://8az33ud0e5.execute-api.us-west-2.amazonaws.com/prod/v1/log'
};

export const SaveReportColumnDefinitions = [
  {
    id: "variable",
    header: "Report Attributes",
    cell: item => item.name || "-"
  },
  {
    id: "value",
    header: "Values",
    cell: item => item.value || "-"
  }
];

export const MapperPaginationSize = 25;

export const AccuracyGranularity = {
  COMPONENT: 'component',
  PRODUCTLINE: 'productline',
};


// WEBPACK FOOTER //
// ./src/constants/constants.jsx